export const APP_NAME = process.env.REACT_APP_NAME;
export const API_URL = process.env.REACT_APP_API + "/api";
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const AUTH_LOCALSTORAGE_NAME = `${APP_NAME}-AUTH-LOGIN`;
export const MAP_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
export const SECRET_KEY = process.env.REACT_APP_HASH_SECRET as string;

export const dbDateFormat = "YYYY-MM-DD";
